<a [routerLink]="link.length ? link : ['/dashboard', route]"
   routerLinkActive="bg-secondary/10 text-secondary font-medium"
   [routerLinkActiveOptions]="{ exact: true }"
   class="flex items-center w-full px-4 py-2.5 rounded-lg font-medium text-gray-600 hover:bg-gray-100 hover:text-gray-900 no-underline transition-colors">
  <span class="flex items-center gap-3">
    <span class="material-symbols-outlined text-[20px] leading-none">{{ icon }}</span>
    <span class="text-sm">{{ name }}</span>
  </span>
</a>
